module.exports = __webpack_public_path__ + "img/3_gst_logo.cda48938.svg";